import styled from 'styled-components';

export const Details = styled.div`
  width: 100%;

  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem !important;
  }
  .button-download {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  [aria-label='download-button'] {
    svg {
      width: 24px;
      height: 24px;
    }
  }
`;
